import { Injectable } from "@angular/core";
import { ApiService } from "./api.service";
import { AppConstants } from "../constants/app.contants";
import { environment } from "src/environments/environment";
import { lastValueFrom } from "rxjs";
import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { LoaderService } from "./loader.service";
import { BaseResponseDTO } from "src/app/core/models/app.models";
import { UserService } from "./user.service";
import { AuthenticationActions } from "src/app/modules/authentication/components/models/authentication-actions.enum";

@Injectable ({
  providedIn: 'root',
})
export class SharedOTPDialogService {
  private _dialogVisible: boolean = false;
  private _content: string = '';
  private _header: string = '';
  private _processname!: AuthenticationActions;  // Store data
  private _callback: ((data?: any) => void) | null = null;  // Callback now accepts optional data
  private _data: any;  // Store data
  otpError: string | null = null;
  resendSuccess: boolean = false;
  resendError: boolean = false;
  resendSuccessMessage: string = "A new OTP has been sent to your email and mobile number.";
  resendErrorMessage: string = "There was an error resending the OTP. Please try again.";
  isProcessCompleted: boolean = false;

  constructor(
    private _http: HttpClient,
    private loaderService: LoaderService,
    private _userService: UserService,

  ) {
    
  }


   // Method to clear the messages
   clearMessages() {
    this.otpError = null;
    this.resendSuccess = false;
    this.resendError = false;
  }

  // Getters

  
  get dialogVisible(): boolean {
    return this._dialogVisible;
  }

  get content(): string {
    return this._content;
  }

  get header(): string {
    return this._header;
  }

  get data(): any {
    return this._data;  // Return the data passed to the dialog
  }

  get processName(): any {
    return this._processname;  // Return the data passed to the dialog
  }


  
  // Show dialog with callback and data
  showDialog(header: string, content: string, processName : any ,callback: (data?: any) => void, data: any): void {
    this._dialogVisible = true;
    this._header = header;
    this._content = content;
    this._callback = callback;  // Set the callback function
    this._data = data;          // Set the data
    this._processname = processName;

    // Send OTP when the dialog is shown
    this.sendOTP();

  }

  // Hide dialog and reset callback and data
  hideDialog(): void {
    this._dialogVisible = false;
    this._header = '';
    this._content = '';
    this._callback = null;  // Reset callback
    this._data = null;      // Reset data
    this._processname;
    this.clearMessages();
    this.isProcessCompleted = false;
  }

  // Execute callback and pass the data
  executeCallback(): void {
    if (this._callback) {
      this._callback(this._data);  // Pass data when invoking callback
    }
  }

// Resend OTP logic moved from component to service
public async sendOTP(): Promise<[boolean, string]> {

  this.loaderService.showLoader(); // Show loader during the API call
  const apiService = this.createApiService();

  const payload = {
    Email: this._userService.user?.EmailAddress,
  };

  try {
    // Explicitly cast the response to BaseResponseDTO
    const response = await this.fireResendOTPRequest(apiService, payload) as unknown as BaseResponseDTO;

    if (response.isSuccess) {
      return [true, response.errorMessageEn || ''];
    } else {
      return [false, response.errorMessageEn || 'Failed to send OTP.'];
    }

  } catch (err: any) {  // Change to 'any' or 'unknown' to fix the error
    console.error('Error resending OTP:', err);
    return [false, 'An error occurred while sending OTP.'];

  } finally {
    this.loaderService.hideLoader(); // Hide the loader after the API call completes
  }
}


    private fireResendOTPRequest(apiService: ApiService, payload: any) {
      let req$ = apiService.post(AppConstants.CONTROLLERS.ACCOUNT, AppConstants.ACTIONS.Generateotp, true, environment.APIs_PREFIX, payload);
      return lastValueFrom(req$); // Convert observable to a promise
    }

    private createApiService(): ApiService {
      const apiService = new ApiService(this._http);
      apiService['_baseUrl'] = environment.API_URL; // Set the base URL manually
      return apiService;
    }

    
}
